import React, { useEffect } from 'react';
import './index.css';
import { useQueryParms } from '../../hooks/useQueryParams';
import axios from 'axios';
import { useGetPlayerInfo } from './hooks/useGetPlayerInfo';

const PlayerProfileScreen = ()=>{
    const { playerInfo } = useGetPlayerInfo()

    return(<div style={{display:'flex', justifyContent:'center'}}>
        <div className='subcontainer-playerprofile'>
            <div className='subcontainer-playerprofile-playerinfo'>
                <div className='subcontainer-playerprofile-playerinfo-profesional-career-title'>
                <p style={{color:'black'}}>Información</p>

                </div>
                <img height={100} width={100} src={playerInfo?.img} />
                <p><strong>Nombre:</strong> {playerInfo?.basePlayer?.name}</p>
                <p><strong>Nacionalidad:</strong> {playerInfo?.basePlayer?.nationality}</p>
                <p><strong>Posicion:</strong> {playerInfo?.basePlayer?.position}</p>
            </div>
            <div className='subcontainer-playerprofile-playerinfo-profesional-career'>
                <div className='subcontainer-playerprofile-playerinfo-profesional-career-title'>
                <p>Carrera Profesional</p>
                </div>
                {
                    playerInfo?.basePlayer?.career?.map((team, index)=>(
                        <div className='playerinfo-item-team' style={{display:'flex', alignItems:'center'}}>
                            <img className='playerProfile-img-team' width={25} height={25} src={team?.img} />
                            <p>{team?.team} - {team?.fromYear}</p>
                        </div>
                    ))
                }

            </div>
            <div className='subcontainer-playerprofile-playerinfo-profesional-career'>
                <div className='subcontainer-playerprofile-playerinfo-profesional-career-title'>
                <p>Titulos en la talacha</p>

                </div>
                {
                    playerInfo?.basePlayer?.trophies?.map((trophy, index)=>(
                        <div className='playerinfo-item-throphy' style={{display:'flex', alignItems:'center', margin:'10px 0'}}>
                            <img className='playerProfile-img-trophy'  src={trophy?.img} />
                            <p>{trophy?.name}</p>
                        </div>
                    ))
                }

            </div>

        </div>

    </div>)
}

export default PlayerProfileScreen


